export default __webpack_public_path__ + "static/media/icon-check.bb8e87b0.svg";